var heroCarousel = {
    init : function(){
        
        $slider = $( '.hero-carousel');
        $slider.owlCarousel({
            nav:false,
            dots: false,
            mouseDrag:false,
            touchDrag:false,
            pullDrag:false,
            items:1,
            responsive:{
                0:{
                    items:1
                },
                576:{
                    items:1
                },
                992:{
                    items:1
                }
            }
        });


      
        $('.carousel-controls.btn-prev').click(function() {
            $( '.product-gallery').trigger('prev.owl.carousel');
        });
        // Go to the previous item
        $('.carousel-controls.btn-next').click(function() {
            $( '.product-gallery').trigger('next.owl.carousel');
        });

       
    }
}